<template>
  <div id="bjzc-layout">
    <div class="bjzc-layout--top-image uk-background-cover" :class="{ en: $i18n.locale === 'en' }">
      <canvas width="1440" height="300"></canvas>
    </div>
    <div class="bjzc-layout--breadcrumb uk-container uk-flex uk-flex-middle uk-overflow-auto">
      <span uk-icon="icon: location;ratio: 0.8;" class="uk-flex-none" style="margin-right: 10px"></span>
      <span class="uk-text-small uk-flex-none">{{ $t('messages.page_location') }}</span>
      <ul class="uk-breadcrumb">
        <li v-for="item in breadcrumb" :key="item.path">
          <router-link :to="item.path">{{ item[currentTitleKey] }}</router-link>
        </li>
      </ul>
    </div>
    <div class="bjzc-layout--main">
      <div class="uk-container">
        <router-view class=""></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      breadcrumb: []
    }
  },
  computed: {
    currentTitleKey() {
      return this.$i18n.locale === 'zh' ? 'title' : 'title_en'
    }
  },
  created() {
    this.$eventBus.$on('setBreadcrumb', breadcrumb => {
      this.breadcrumb = breadcrumb
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('setBreadcrumb')
  },
  methods: {}
}
</script>

<style lang="scss">
#bjzc-layout {
  .bjzc-layout--main {
    background-color: #fff;
    background-image: url('~@/assets/images/bg/layout.png');
    padding: 5rem 0 3.75rem;
    background-position: 0% bottom;
    background-repeat: repeat-x;
  }
  .bjzc-layout--top-image {
    min-height: 8.6rem;
    background-image: url('~@/assets/images/top-image.png');

    &.en {
      background-image: url('~@/assets/images/top-image_en.png');
    }
  }
  /* breadcrumb */
  .bjzc-layout--breadcrumb {
    height: 2.5rem;
    .uk-breadcrumb {
      flex-wrap: nowrap;
      margin: 0;
      min-width: 0;
    }
    .uk-breadcrumb > * > * {
      color: #494d54;
      line-height: 1.5rem;
    }
    .uk-breadcrumb > :not(:last-child) > :hover {
      text-decoration: underline;
    }
    .uk-breadcrumb > :last-child > * {
      color: #ff6600;
      cursor: default;
      pointer-events: none;
    }
    .uk-breadcrumb > :nth-child(n + 2):not(.uk-first-column)::before {
      margin: 0 4px;
      font-size: 0.88rem;
    }
  }
}
@media (max-width: ($screen-width-m - 1)) {
  #bjzc-layout .bjzc-layout--main {
    padding: 2.5rem 0 1.88rem;
    background-image: none;
  }
}
</style>
